import { useFeatureFlagContext } from '../providers/FeatureFlagProvider';

/**
 * Convenience hook for a single flag
 * @param {string} flagName — from FeatureFlagName
 * @returns {boolean} enabled
 */
export const useFeatureFlag = (flagName) => {
    const { isEnabled, loading, error } = useFeatureFlagContext();
    return {
        enabled: isEnabled(flagName),
        loading,
        error,
        isEnabled,
    };
};

export default useFeatureFlag;
